var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.eventWrapperClasses},[_c('strong',[_vm._v(_vm._s(_vm.evento.name))]),_vm._v(", "+_vm._s(_vm.getEventoHorarioFromDateTime(_vm.evento.start))+" - "+_vm._s(_vm.getEventoHorarioFromDateTime(_vm.evento.end))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }